import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import DealerCarInfoHeader from "./components/DealerCarInfoHeader";
import Interventions from "./components/Interventions";
import Checks from "./components/Checks";
import LabelImages from "./components/LabelImages";
import { normalizeAppointmentData, getAllImages } from "./util";

import Service from "./service";

import "./index.scss";
class MultiCheckReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      failedToLoad: false,
      appointment: null,
    };
  }

  componentDidMount = () => {
    const { match } = this.props;
    const routeKey = match.params.routeKey;

    if (routeKey) {
      Service.loadReport(routeKey)
        .then(result => {
          if (result.data?.data?.report) {
            try {
              const appointment = JSON.parse(result.data.data.report);

              this.setState({
                appointment: normalizeAppointmentData(appointment),
                failedToLoad: false,
              });
            } catch (e) {
              this.setState({ failedToLoad: true });
              console.log("Failed to parse data", e);
            }
          } else {
            this.setState({ failedToLoad: true });
            console.log("Failed to load report");
          }
        })
        .catch(err => {
          this.setState({ failedToLoad: true });
          console.log("Failed to load report", err);
        });
    } else this.setState({ failedToLoad: true });
  };

  render() {
    const { failedToLoad, appointment } = this.state;

    if (failedToLoad || !appointment) return null;

    const images = getAllImages(appointment);

    return (
      <div className="MultiCheckReport">
        <DealerCarInfoHeader appointment={appointment} />
        <Interventions interventions={appointment.interventions} settings={appointment.dealer_location} />
        {appointment.checks.map(check => (
          <Checks key={check.id} check={check} settings={appointment.dealer_location} />
        ))}
        {images?.length > 0 && <LabelImages images={images} />}
      </div>
    );
  }
}

export default withRouter(MultiCheckReport);
